export const lostPreventionSteps = [
  {
    id: "step-1",
    icon: "ri-bookmark-3-line",
    title: "立刻收藏本页",
    desc: "本页是固定的信息汇总页，网址相对稳定。把它加入浏览器书签，地址变化时回到这里就能看到最新入口。",
  },
  {
    id: "step-2",
    icon: "ri-smartphone-line",
    title: "添加到手机主屏幕",
    desc: "在手机浏览器菜单中选择「添加到主屏幕」，本页就会像APP一样出现在桌面，点一下即可打开查看最新地址。",
  },
  {
    id: "step-3",
    icon: "ri-file-copy-2-line",
    title: "手动记录备用地址",
    desc: "把本页列出的主线路与备用线路各记下一条，写在备忘录或便签里，避免完全依赖单一入口。",
  },
  {
    id: "step-4",
    icon: "ri-history-line",
    title: "定期回访核对",
    desc: "建议每隔一段时间回来查看更新记录。地址发生调整时，本页会同步反映，回访即可确认当前可用入口。",
  },
    {
    id: "step-5",
    icon: "ri-shield-keyhole-line",
    title: "记住主入口特征",
    desc: "留意主站页面结构与标识，形成自己的辨识习惯。遇到排版粗糙、要求额外输入敏感信息的页面要及时退出。",
  },
    {
    id: "step-6",
    icon: "ri-device-line",
    title: "多设备留一份",
    desc: "在手机、电脑上各存一份收藏或备注。某台设备打不开时，换另一台设备打开本页仍然能看到最新地址。",
  },
];

export const whyAddressChanges = [
  {
    id: "why-1",
    title: "域名会定期轮换",
    desc: "出于运营需要，平台的访问域名通常不会长期固定，会在一定周期后进行调整，旧地址可能逐步失效。",
  },
  {
    id: "why-2",
    title: "网络环境存在差异",
    desc: "不同地区、不同运营商的网络线路状况不一致，同一条地址在不同网络下的打开速度可能相差明显。",
  },
  {
    id: "why-3",
    title: "单一入口风险高",
    desc: "只记住一个地址，一旦它临时不可用，就容易陷入搜不到入口的状态。多记录几条能显著降低这种风险。",
  },
];